<div class="header">
  <ion-icon name="checkmark-outline" (click)="confirm()" class="header-button"></ion-icon>
  <ion-icon name="close-outline" (click)="cancel()" class="header-button"></ion-icon>
</div>

<div class="content">

  <div class="title">
    Substitutos para {{documentoMatriculaRapidaPrincipal?.configuracaoDocumento.nomeDocumento}}
  </div>

  <span *ngFor="let configuracaoDocumento of padMatricula?.configuracoesDocumentos">
    <ion-item *ngIf="configuracaoDocumento.id !== documentoMatriculaRapidaPrincipal?.configuracaoDocumento.id">
      
      <ion-checkbox (ionChange)="addSubstitute($event, configuracaoDocumento)" [checked]="docAdded(configuracaoDocumento)"></ion-checkbox>
      &nbsp;{{configuracaoDocumento.nomeDocumento}}

    </ion-item>
  </span>


  <div class="flex-box" style="margin-top: 50px;">
    <div>
      <ion-button class="cancel-button" (click)="cancel()">Cancelar</ion-button>
    </div>
    <div>
      <ion-button class="cancel-button" (click)="confirm()">Confirmar</ion-button>
    </div>
  </div>
  
</div>